"use client";

import { Core } from "@faire/design-tokens";
// eslint-disable-next-line @faire-localization/no-restricted-imports
import { strictLocalize } from "@faire/web/common/localization";
import * as React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1683))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.261Z
 */
export const Block = createSVGIcon(
  <>
    <path
      d="M0.856934 12C0.856934 14.9553 2.03091 17.7895 4.1206 19.8792C6.21029 21.9689 9.04452 23.1429 11.9998 23.1429C14.9551 23.1429 17.7893 21.9689 19.879 19.8792C21.9687 17.7895 23.1426 14.9553 23.1426 12C23.1426 9.04477 21.9687 6.21054 19.879 4.12085C17.7893 2.03115 14.9551 0.857178 11.9998 0.857178C9.04452 0.857178 6.21029 2.03115 4.1206 4.12085C2.03091 6.21054 0.856934 9.04477 0.856934 12V12Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.12109 19.8788L19.8788 4.12109"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,

  "Block",
  {
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Block",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  }
);
